export function setCloudProxy(state, payload) {
    state.cloudProxy = payload.cloud_proxy;
}

export function setUpcomingEvents(state, payload) {
  state.upcomingEvents = payload;
}

export function setEventDetails(state, payload) {
    state.eventDetails = payload;
}

export function setDominantSpeaker(state, dominantSpeaker) {
    state.dominantSpeaker = dominantSpeaker
}

export function setOngoingSessionData(state, session) {
    state.ongoingSession = session.isJoined
    state.ongoingSessionID = session.session_id
}

export function setOngoingSessionStatus(state, status) {
    state.ongoingSession = status
}

export function setEventSlotFirebase(state, eventSlotFirebase) {
    state.eventSlotFirebase = eventSlotFirebase
}

export function showSurveyPopupModal(state, forceLeave) {
    state.forceLeave = forceLeave
}

export function setSurveyPopupModal(state, payload) {
    state.showSurveyPopupModal = payload
}


export function showHideSettingsModal(state, payload) {
    state.showAvSettingsModal = payload
}

export function showHideTurboBridgeModal(state, payload) {
    state.showTurboBridgeModal = payload
}

export function setCurrentVideoSettings(state, payload) {
    state.currentVideoSettings = payload
}

export function setMeetingJoiningStatus(state, payload) {
    state.meetingJoined = payload
}

export function setCurrentSessionJoinTime(state, payload) {
    state.currentSessionJoinTime = payload
}

export function resetStore(state) {
    state.upcomingEvents = null
    state.eventDetails = {}
    state.meetingJoined = false
    state.dominantSpeaker = null
    state.surveyNotifications = []
    state.forceLeave = false
    state.ongoingSession = false
    state.ongoingSessionID = ""
    state.eventSlotFirebase = null
    state.showSurveyPopupModal = false
}
